import { MfaSourceTypeEnum } from "../../common/enums/MfaSourceTypeEnum";
import { UILanguage } from "../../common/enums/UILanguage";
import { GaugeSheetViewMode } from "../../views/gauge-sheet-view/GaugeSheetState";

export enum MarketingReportPreferenceSortDateEnum {
    LeftToRight = 1,
    RightToLeft = 2
};

export enum TagHistoryViewEnum {
    Chart = 0,
    Grid = 1
};

//Namespace not marked type-only declare. Non-declarative namespaces are only supported exp
//export namespace Trending {
    export enum DataTooltipDisplayEnum {
        Shared = 0,
        Separate = 1
    };
//};



 export enum UIShortcutEnum
 {
     HistoricalData = 1,
     Graph = 2,
     MarketingReport = 4,
     PlungerAnalysis = 8,
     GaugeSheet = 16,
     Dynacard = 32,
     AddMemo = 64,
     MapIt = 128
 }

export interface IUserSettings {
    language: UILanguage;
    gridRowCount: number;
    unitSetID: number;
    summaryListingDisplayFunctionIcons: boolean;
    summaryListingAlarmAtTop: boolean;
    summaryListingOutletsFirst: boolean;
    marketingReportSortDate: MarketingReportPreferenceSortDateEnum;
    tagHistoryView: TagHistoryViewEnum;
    trendDefaultYAxesVisible: boolean;
    trendingDataTooltipDisplay: DataTooltipDisplayEnum;
    trendingNumberChartsInViewport: number;
    primaryAPIKey?: string;
    secondaryAPIKey?: string;
    devPortalURL?: string;
    primaryAPIKeyExpiration?: Date;
    secondaryAPIKeyExpiration?: Date;
    defaultDeviceView: boolean;
    mfaAccount: string;
    mfaEnabled: boolean;
    mfaSource: MfaSourceTypeEnum;
    mfaSecret: string;
    mfaRequired: boolean;
    authenticationGuid?: string;
    otpLastVerified?: string;
    theme?: string,
    collapseTagGroups: boolean
    gridFontSize?: number;
    gridCellPadding?: number;

    gaugeSheetViewMode?: GaugeSheetViewMode;
    gaugeSheetShowDevice?: boolean;
    gaugeSheetShowTanks?: boolean;

    tankLevelInches?: boolean;

    uiShortcutMask?: number;
};


